<template lang="">
    <div class="login-container">
        <el-form
            :model="loginObj.loginForm"
            status-icon
            :rules="loginObj.loginRules"
            ref="loginFormRef"
            class="login-form"
        >
            <h1>用户登录</h1>
            <el-form-item label="" prop="username">
                <el-input
                    v-model="loginObj.loginForm.username"
                    size="large"
                    autocomplete="off"
                    placeholder="请输入用户名"
                    :prefix-icon="User"
                ></el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
                <el-input
                    type="password"
                    v-model="loginObj.loginForm.password"
                    size="large"
                    placeholder="请输入密码"
                    autocomplete="off"
                    :prefix-icon="Lock"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm(loginFormRef)" size="large" class="login-btn"
                    >登 录</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>
<script setup>
import { ref, reactive } from 'vue';
import { User, Lock } from '@element-plus/icons-vue';
import cookie from '@/commons/cookie.js';
import request from '@/request/index';
import { useRouter } from 'vue-router';
const loginObj = reactive({
    loginForm: {},
    loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }]
    }
});

const router = useRouter();
const loginFormRef = ref();
const submitForm = formEl => {
    if (!formEl) return;
    formEl.validate(async valid => {
        if (valid) {
            console.log(loginObj.loginForm);
            const rsp = await request('login', loginObj.loginForm);
            if (rsp.status === 200) {
                localStorage.setItem('userinfo', JSON.stringify(rsp.data));
                cookie.setCookie('token', rsp.data.token);
                router.push({
                    name: 'saleNets'
                });
            }
        } else {
            console.log('error submit!');
            return false;
        }
    });
};
</script>
<style scoped lang="scss">
.login-container {
    height: 100%;
    width: 100%;
    background-image: url('../../assets/login-bg.png');
    background-size: 100% 100%;
    background-position: center;
    .login-form {
        width: 360px;
        margin-left: auto;
        margin-right: auto;
        padding-top: 180px;
        text-align: center;
    }
    .login-btn {
        width: 100%;
        margin-top: 40px;
    }
}
</style>
